import SimpleFormPage from "../common/SimpleFormPage";
import TagFields from "./TagFields";

export default function NewTag() {
  return (
    <SimpleFormPage title="Nuovo tag">
      <TagFields />
    </SimpleFormPage>
  );
}
